
import { BlogPost } from "@/types/blog";
import { fairDealOverview } from "./fair-deal-overview";
import { choosingNursingHome } from "./choosing-nursing-home";
import { transitionGuide } from "./transition-guide";

export const blogPosts: BlogPost[] = [
  fairDealOverview,
  choosingNursingHome,
  transitionGuide,
];

export const getBlogPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find(post => post.slug === slug);
};
